import React, { useState } from "react";
import { FetchShopDetails } from "../api/fetchShopDetails";
import axios from "axios";
export default function ShopData() {
  const [shopDetails, setShopDetails] = useState(null);

  const getDataShop = async () => {
    try {
      const data = await FetchShopDetails();
      setShopDetails(data);
    } catch (error) {
      console.error("Error getting shop details:", error);
    }
  };

  console.log("shopDetails", shopDetails);

  const deleteWebhook = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;

      const res = await axios.post(`${apiUrl}/api/delete`);
      console.log(res, "testing");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="container">
        <p className="text-danger fs-2 text-center mt-3">
          hobbyDB Shopify Shop Details
        </p>

        <button className="btn btn-rounded btn-warning" onClick={getDataShop}>
          Click here for product details.
        </button>

        <button className="btn btn-rounded btn-warning" onClick={deleteWebhook}>
          Click here for product deleteWebhook.
        </button>
      </div>
    </>
  );
}
